/**
 * View component for /groups/secure-landing?params
 * @grantfowler: "that page should NOT load the group yet, but should throw up a generic "loading/checking/something" message while user waits 
 * it should take all of those params, which might be varied, and POST them to a new group endpoint"
 * 
 * The response should inform the UI to either:
 *  display error message
 *  redirect to the group landing page (which will handle login check)
 *
 */

// import primary libraries
import React from 'react'

// import third-party libraries
import { Redirect } from 'react-router-dom'
import { safeRedirect } from '../../../global/utils/linkUtils.js';

// import global level
import DefaultLayout from '../../../global/components/layouts/DefaultLayout'
import UserLayout from '../../user/components/UserLayout.jsx';

// import resource level
import { useSecureGroupLanding } from '../groupService'
import { useURLSearchParams } from '../../../global/utils/customHooks'


const GroupSecureLanding = () => {
  const [params] = useURLSearchParams();

  const { redirect, message, organizationId, isLoading } = useSecureGroupLanding(params);

  const { groupId, email: rawEmail } = params;

  const email = rawEmail?.replace(' ', '+') // we want to preserve the + here. only replace the first occurance. if there are two +'s, it will remain invalid.

  // redirect to the group landing page, pass email along to pre-fill the username field on the login form if they're not logged in
  if (redirect && params?.redirect) {
    safeRedirect(`${params.redirect}?email=${email}`)
  } else if (redirect && organizationId && groupId) {
    return <Redirect to={`/${organizationId}/${groupId}?email=${email}`} />
  } else if (redirect) {
    // missing some required info, just go home
    return <Redirect to={`/`} />
  }

  return (
    <UserLayout title={'Welcome'} className="bg-neutral-sec">
      <div className="flex flex-col items-center min-h-full h-screen">
        <div className="text-center">
          <h1 className="text-3xl font-semibold mb-2">Welcome to your group!</h1>
          {isLoading && <p className="text-lg mb-4 animate-pulse">Checking your credentials...</p>}
          {message && <p className="text-lg mb-4">{message}</p>}
        </div>
      </div>
    </UserLayout>
  )
}

export default GroupSecureLanding;